import { takeLatest, put } from 'redux-saga/effects';
import { GET_RESERVATION_DATE_REQUEST, GET_RESERVATION_DATE_CHECK_DATA } from './constants';
import { getReservationDateSuccess, getReservationDateFailure, getReservationCheckDataFailure } from './actions';
import _ from 'lodash';
import * as Api from '../../../services';
import { setStepStorageByPath } from '../../private-route/utils';

const mappingData = (data) => {
  return data.map(val => {
    return {
      ReservationDate: val.reservationDate,
      HasAmSlot: val.slots[0].available,
      HasPmSlot: val.slots[1].available,
      ReservationDateAmId: val.slots[0].reservationDateId,
      ReservationDatePmId: val.slots[1].reservationDateId,
      reservedFlgAm: val.slots[0].reservedFlg,
      reservedFlgPm: val.slots[1].reservedFlg,
    }
  });
}

function* fetchApiCalendar() {
  return yield Api.getDataCalendar();
}

function urls() {
  return localStorage.getItem('_bookingNumber');
}

function owner() {
  return localStorage.getItem('Owner');
}

function* checkData(action) {
  const response = yield fetchApiCalendar();
  const { id, date, from } = action;
  if (response.data.isSuccess) {
    const index = _.findIndex(response.data.rows, { reservationDate: date, slots: [{ reservationDateId: id.toString() }] });
    const reBooking = localStorage.getItem("reBooking");
    let link = '';

    if (urls() !== null) {
      link = `/booking-information${from}`;
    } else {
      link = reBooking === 'on' ? `/booking-information${from}` : '/register-option';
    }

    if(owner() === null) {
      link = `/booking-information${from}`;
    } else {
      link = '/register-option';
    }

    setStepStorageByPath(link);

    const mapData = yield mappingData(response.data.rows);
    index === -1 ?
      yield put(getReservationCheckDataFailure({ mapData, error: true })) :
      action.history.push(link);
  }
}

function* fetchGetReservation() {
  const response = yield fetchApiCalendar();
  if (response.data.isSuccess) {
    const { data } = response.data;
    localStorage.setItem('lockVersion', data)
    const mapData = yield mappingData(response.data.rows);
    yield put(getReservationDateSuccess(mapData))
  }

  if (!response.data.isSuccess) {
    yield put(getReservationDateFailure(response.data))
  }
}

export function* saga() {
  yield takeLatest(GET_RESERVATION_DATE_REQUEST, fetchGetReservation);
  yield takeLatest(GET_RESERVATION_DATE_CHECK_DATA, checkData);
}
